/* Bread Studio — Stages 1, 2 & 3 JS
 * Extracted from sections/bread-studio.liquid
 * No Liquid variables — plain JS asset file
 */

var BS_STYLES = {
  boule:    { hydration: 75, salt: 2,   fat: 0,  preFerment: 'levain', preFermentPct: 20 },
  batard:   { hydration: 75, salt: 2,   fat: 0,  preFerment: 'levain', preFermentPct: 20 },
  tin:      { hydration: 72, salt: 2,   fat: 2,  preFerment: 'levain', preFermentPct: 20 },
  focaccia: { hydration: 80, salt: 2,   fat: 8,  preFerment: 'levain', preFermentPct: 20 },
  enriched: { hydration: 55, salt: 1.5, fat: 15, preFerment: 'none',   preFermentPct: 0  },
  rolls:    { hydration: 68, salt: 2,   fat: 3,  preFerment: 'levain', preFermentPct: 15 }
};

var BS_NOTES = {
  boule:    'For an open crumb, aim for 75\u201380% hydration and a 4-hour bulk at 24\u00b0C.',
  batard:   'An oval batard holds tension better than a boule, and is great for high-hydration doughs.',
  tin:      'Dust the tin lightly with flour and oil the sides for a clean release.',
  focaccia: 'Dimple generously, add flaky salt and good olive oil just before baking.',
  enriched: 'Enriched doughs need a longer proof. Check by the poke test, not just the clock.',
  rolls:    'Shape rolls tight for a better rise; a loose roll spreads flat.'
};

function bsInputsHTML(slug) {
  if (slug === 'boule' || slug === 'batard') {
    return '<div class="bs-inputs__section"><label class="bs-label">Dough weight per loaf (g)</label><input class="bs-input" type="number" id="bs-loaf-weight" value="850" min="200" max="3000" oninput="bsCalc()"></div><div class="bs-inputs__section"><label class="bs-label">Number of loaves</label><input class="bs-input" type="number" id="bs-loaf-count" value="1" min="1" max="10" oninput="bsCalc()"></div>';
  }
  if (slug === 'tin') {
    return '<div class="bs-inputs__section"><label class="bs-label">Tin presets</label><div class="bs-presets"><button class="bs-preset-btn" onclick="bsSetPreset({l:23,w:13,h:7})">2lb tin</button><button class="bs-preset-btn" onclick="bsSetPreset({l:18,w:9,h:6})">1lb tin</button><button class="bs-preset-btn" onclick="bsSetPreset({l:30,w:10,h:10})">Pullman</button></div></div><div class="bs-inputs__section"><label class="bs-label">Dimensions (cm)</label><div class="bs-inputs__dims"><div><label class="bs-label">L</label><input class="bs-input" type="number" id="bs-tin-l" value="23" min="1" oninput="bsCalc()"></div><div><label class="bs-label">W</label><input class="bs-input" type="number" id="bs-tin-w" value="13" min="1" oninput="bsCalc()"></div><div><label class="bs-label">H</label><input class="bs-input" type="number" id="bs-tin-h" value="7" min="1" oninput="bsCalc()"></div></div></div><div class="bs-inputs__section"><label class="bs-label">Number of tins</label><input class="bs-input" type="number" id="bs-tin-count" value="1" min="1" max="10" oninput="bsCalc()"></div>';
  }
  if (slug === 'focaccia') {
    return '<div class="bs-inputs__section"><label class="bs-label">Shape</label><div class="bs-presets"><button class="bs-preset-btn bs-preset-btn--active" id="bs-foc-rect-btn" onclick="bsToggleFocacciaShape(\'rect\')">Rectangle</button><button class="bs-preset-btn" id="bs-foc-round-btn" onclick="bsToggleFocacciaShape(\'round\')">Round</button></div></div><div class="bs-inputs__section"><label class="bs-label">Tray presets</label><div class="bs-presets"><button class="bs-preset-btn" onclick="bsSetFocacciaTray(\'half\')">Half sheet</button><button class="bs-preset-btn" onclick="bsSetFocacciaTray(\'full\')">Full sheet</button><button class="bs-preset-btn" onclick="bsSetFocacciaTray(\'round30\')">Round 30cm</button></div></div><div id="bs-foc-rect-inputs" class="bs-inputs__section"><label class="bs-label">Dimensions (cm)</label><div class="bs-inputs__dims-2"><div><label class="bs-label">W</label><input class="bs-input" type="number" id="bs-foc-w" value="32" min="1" oninput="bsCalc()"></div><div><label class="bs-label">L</label><input class="bs-input" type="number" id="bs-foc-l" value="26" min="1" oninput="bsCalc()"></div></div></div><div id="bs-foc-round-inputs" class="bs-inputs__section" style="display:none"><label class="bs-label">Radius (cm)</label><input class="bs-input" type="number" id="bs-foc-r" value="15" min="1" oninput="bsCalc()"></div>';
  }
  if (slug === 'enriched') {
    return '<div class="bs-inputs__section"><label class="bs-label">Shape</label><div class="bs-presets"><button class="bs-preset-btn bs-preset-btn--active">Loaf</button><button class="bs-preset-btn">Couronne</button><button class="bs-preset-btn">Buns</button><button class="bs-preset-btn">Babka</button></div></div><div class="bs-inputs__section"><label class="bs-label">Dough weight per item (g)</label><input class="bs-input" type="number" id="bs-enr-weight" value="750" min="100" oninput="bsCalc()"></div><div class="bs-inputs__section"><label class="bs-label">Number of items</label><input class="bs-input" type="number" id="bs-enr-count" value="1" min="1" max="6" oninput="bsCalc()"></div>';
  }
  if (slug === 'rolls') {
    return '<div class="bs-inputs__section"><label class="bs-label">Number of rolls</label><input class="bs-input" type="number" id="bs-roll-count" value="12" min="4" max="24" oninput="bsCalc()"></div><div class="bs-inputs__section"><label class="bs-label">Weight per roll (g)</label><input class="bs-input" type="number" id="bs-roll-weight" value="80" min="50" max="150" oninput="bsCalc()"></div>';
  }
  return '';
}

function bsSelectStyle(slug, openStage2) {
  document.querySelectorAll('.bs-card').forEach(function(c) {
    var active = c.dataset.style === slug;
    c.classList.toggle('bs-card--active', active);
    c.setAttribute('aria-checked', active ? 'true' : 'false');
    c.setAttribute('tabindex', active ? '0' : '-1');
  });
  var panel = document.getElementById('bs-inputs-panel');
  if (panel) { panel.innerHTML = bsInputsHTML(slug); }
  bsCalc();
  if (openStage2 !== false) {
    bsOpenStage2();
    bsSeedStage2(slug);
  }
}

function bsCalc() {
  var activeCard = document.querySelector('.bs-card--active');
  var slug = activeCard ? activeCard.dataset.style : 'boule';
  var defs = BS_STYLES[slug];
  var loafWeight = 850, totalDough = 850, loafCount = 1;

  if (slug === 'boule' || slug === 'batard') {
    loafWeight = parseFloat(document.getElementById('bs-loaf-weight') && document.getElementById('bs-loaf-weight').value) || 850;
    loafCount  = parseInt(document.getElementById('bs-loaf-count') && document.getElementById('bs-loaf-count').value) || 1;
    totalDough = loafWeight * loafCount;
  } else if (slug === 'tin') {
    var tl = parseFloat(document.getElementById('bs-tin-l') && document.getElementById('bs-tin-l').value) || 23;
    var tw = parseFloat(document.getElementById('bs-tin-w') && document.getElementById('bs-tin-w').value) || 13;
    var th = parseFloat(document.getElementById('bs-tin-h') && document.getElementById('bs-tin-h').value) || 7;
    loafWeight = Math.round(tl * tw * th * 0.45);
    loafCount  = parseInt(document.getElementById('bs-tin-count') && document.getElementById('bs-tin-count').value) || 1;
    totalDough = loafWeight * loafCount;
  } else if (slug === 'focaccia') {
    var roundInputs = document.getElementById('bs-foc-round-inputs');
    var isRound = roundInputs && roundInputs.style.display !== 'none';
    if (isRound) {
      var fr = parseFloat(document.getElementById('bs-foc-r') && document.getElementById('bs-foc-r').value) || 15;
      loafWeight = Math.round(Math.PI * fr * fr * 0.65);
    } else {
      var fw = parseFloat(document.getElementById('bs-foc-w') && document.getElementById('bs-foc-w').value) || 32;
      var fl = parseFloat(document.getElementById('bs-foc-l') && document.getElementById('bs-foc-l').value) || 26;
      loafWeight = Math.round(fw * fl * 0.65);
    }
    loafCount  = 1;
    totalDough = loafWeight;
  } else if (slug === 'enriched') {
    loafWeight = parseFloat(document.getElementById('bs-enr-weight') && document.getElementById('bs-enr-weight').value) || 750;
    loafCount  = parseInt(document.getElementById('bs-enr-count') && document.getElementById('bs-enr-count').value) || 1;
    totalDough = loafWeight * loafCount;
  } else if (slug === 'rolls') {
    var rollCount  = parseInt(document.getElementById('bs-roll-count') && document.getElementById('bs-roll-count').value) || 12;
    var rollWeight = parseFloat(document.getElementById('bs-roll-weight') && document.getElementById('bs-roll-weight').value) || 80;
    loafWeight = rollWeight;
    loafCount  = rollCount;
    totalDough = rollCount * rollWeight;
  }

  var flourEstimate = Math.round(totalDough / (1 + defs.hydration/100 + defs.salt/100 + defs.fat/100));
  var perLabel = slug === 'rolls' ? 'Weight per roll' : slug === 'focaccia' ? 'Weight per tray' : slug === 'enriched' ? 'Weight per item' : 'Weight per loaf';

  var out = document.getElementById('bs-outputs-panel');
  if (out) {
    out.innerHTML =
      '<div class="bs-output-row"><span class="bs-output-label">' + perLabel + '</span><span class="bs-output-value">' + Math.round(loafWeight) + ' g</span></div>' +
      '<div class="bs-output-row"><span class="bs-output-label">Total dough weight</span><span class="bs-output-value bs-output-value--primary">' + Math.round(totalDough) + ' g</span></div>' +
      '<div class="bs-output-row"><span class="bs-output-label">Quick flour estimate</span><span class="bs-output-value">\u2248 ' + flourEstimate + ' g</span></div>' +
      '<p class="bs-note">' + BS_NOTES[slug] + '</p>';
  }

  window.bs = {
    style: slug,
    slug: slug,
    loafWeight: Math.round(loafWeight),
    totalDough: Math.round(totalDough),
    loafCount: loafCount,
    hydration: defs.hydration,
    salt: defs.salt,
    fat: defs.fat,
    preFerment: defs.preFerment,
    preFermentPct: defs.preFermentPct
  };
  bsCalc2();
}

var BS_FOC_PRESETS = {
  half:    { shape: 'rect',  w: 32, l: 26 },
  full:    { shape: 'rect',  w: 58, l: 39 },
  round30: { shape: 'round', r: 15 }
};

function bsSetPreset(vals) {
  if (vals.l !== undefined) {
    var lEl = document.getElementById('bs-tin-l');
    var wEl = document.getElementById('bs-tin-w');
    var hEl = document.getElementById('bs-tin-h');
    if (lEl) lEl.value = vals.l;
    if (wEl) wEl.value = vals.w;
    if (hEl) hEl.value = vals.h;
  }
  bsCalc();
}

function bsSetFocacciaTray(preset) {
  var p = BS_FOC_PRESETS[preset];
  if (!p) return;
  if (p.shape === 'round') {
    bsToggleFocacciaShape('round');
    var rEl = document.getElementById('bs-foc-r');
    if (rEl) rEl.value = p.r;
  } else {
    bsToggleFocacciaShape('rect');
    var wEl = document.getElementById('bs-foc-w');
    var lEl = document.getElementById('bs-foc-l');
    if (wEl) wEl.value = p.w;
    if (lEl) lEl.value = p.l;
  }
  bsCalc();
}

function bsToggleFocacciaShape(shape) {
  var rectInputs = document.getElementById('bs-foc-rect-inputs');
  var roundInputs = document.getElementById('bs-foc-round-inputs');
  var rectBtn = document.getElementById('bs-foc-rect-btn');
  var roundBtn = document.getElementById('bs-foc-round-btn');
  if (shape === 'round') {
    if (rectInputs)  rectInputs.style.display = 'none';
    if (roundInputs) roundInputs.style.display = '';
    if (rectBtn)  rectBtn.classList.remove('bs-preset-btn--active');
    if (roundBtn) roundBtn.classList.add('bs-preset-btn--active');
  } else {
    if (rectInputs)  rectInputs.style.display = '';
    if (roundInputs) roundInputs.style.display = 'none';
    if (rectBtn)  rectBtn.classList.add('bs-preset-btn--active');
    if (roundBtn) roundBtn.classList.remove('bs-preset-btn--active');
  }
  bsCalc();
}

document.addEventListener('DOMContentLoaded', function() {
  bsSelectStyle('boule', false);
});

// ── Stage 2 ─────────────────────────────────────────────

var BS_PF_HYDRATION = { levain: 100, poolish: 100, biga: 60, none: 0 };
var BS_STYLE_NAMES  = { boule: 'Sourdough Boule', batard: 'Sourdough Batard', tin: 'Tin Loaf', focaccia: 'Focaccia', enriched: 'Enriched / Brioche', rolls: 'Rolls' };

function bsOpenStage2() {
  var acc = document.getElementById('bs-stage2');
  if (acc) acc.classList.add('bs-stage2--open');
}

function bsCloseStage2() {
  var acc = document.getElementById('bs-stage2');
  if (acc) acc.classList.remove('bs-stage2--open');
  var activeCard = document.querySelector('.bs-card--active');
  if (activeCard) activeCard.focus();
}

function bsStartOver() {
  bsCloseStage2();
  bsSelectStyle('boule');
  var bouleCard = document.querySelector('.bs-card[data-style="boule"]');
  if (bouleCard) bouleCard.focus();
}

function bsSeedStage2(slug) {
  var defs = BS_STYLES[slug];
  var summaryEl = document.getElementById('bs-s2-summary-val');
  if (summaryEl && window.bs) {
    summaryEl.textContent = BS_STYLE_NAMES[slug] + ' · ' + window.bs.totalDough + ' g total';
  }
  var recipeStyleEl = document.getElementById('bs-s2-recipe-style-name');
  if (recipeStyleEl) recipeStyleEl.textContent = BS_STYLE_NAMES[slug];

  var hydEl = document.getElementById('bs-s2-hydration');
  if (hydEl) hydEl.value = defs.hydration;
  bsUpdateHydrationLabel();

  var saltEl = document.getElementById('bs-s2-salt');
  if (saltEl) saltEl.value = defs.salt;

  var enrichSec = document.getElementById('bs-s2-enrichment-section');
  if (enrichSec) enrichSec.style.display = (slug === 'enriched') ? '' : 'none';
  if (slug === 'enriched') {
    ['bs-s2-butter','bs-s2-eggs','bs-s2-milk'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.value = 0;
    });
  }

  var blendEl = document.getElementById('bs-s2-flour-blend');
  if (blendEl) blendEl.value = 'white';
  bsHandleFlourChange();

  bsSetPF(defs.preFerment);
  var pfPctEl = document.getElementById('bs-s2-pf-pct');
  if (pfPctEl) pfPctEl.value = defs.preFermentPct;

  bsCalc2();
}

function bsUpdateHydrationLabel() {
  var el  = document.getElementById('bs-s2-hydration');
  var val = document.getElementById('bs-s2-hydration-val');
  if (el && val) val.textContent = el.value;
}

function bsHandleFlourChange() {
  var blendEl = document.getElementById('bs-s2-flour-blend');
  if (!blendEl) return;
  var val = blendEl.value;
  var customDiv = document.getElementById('bs-s2-custom-blend');
  var hintEl    = document.getElementById('bs-s2-wholegrain-hint');
  var errEl     = document.getElementById('bs-s2-blend-error');
  var wholeGrains = ['wholemeal','white-wholemeal','white-rye'];
  if (customDiv) customDiv.style.display = (val === 'custom') ? '' : 'none';
  if (hintEl)    hintEl.style.display    = (wholeGrains.indexOf(val) !== -1) ? '' : 'none';
  if (errEl)     errEl.style.display     = 'none';
  bsCalc2();
}

function bsSetPF(type) {
  ['levain','poolish','biga','none'].forEach(function(t) {
    var el = document.getElementById('bs-s2-pf-' + t);
    if (el) el.classList.toggle('bs-s2-pf-card--active', t === type);
  });
  var extraEl = document.getElementById('bs-s2-pf-extra');
  var hydWrap = document.getElementById('bs-s2-pf-hydration-wrap');
  if (type === 'none') {
    if (extraEl) extraEl.classList.remove('bs-s2-pf-extra--visible');
  } else {
    if (extraEl) extraEl.classList.add('bs-s2-pf-extra--visible');
    if (hydWrap) {
      if (type === 'levain') {
        hydWrap.innerHTML = '<label class="bs-label">Levain hydration %</label><input class="bs-input" type="number" id="bs-s2-pf-hydration-val" value="100" min="50" max="150" oninput="bsCalc2()">';
      } else {
        var h = BS_PF_HYDRATION[type];
        hydWrap.innerHTML = '<label class="bs-label">Hydration</label><div class="bs-s2-readonly">' + h + '%</div><input type="hidden" id="bs-s2-pf-hydration-val" value="' + h + '">';
      }
    }
  }
  bsCalc2();
}

function bsCalc2() {
  var totalDough = (window.bs && window.bs.totalDough) ? window.bs.totalDough : 850;
  var slug       = (window.bs && window.bs.style)      ? window.bs.style      : 'boule';

  var hydEl  = document.getElementById('bs-s2-hydration');
  var saltEl = document.getElementById('bs-s2-salt');
  var hydration = hydEl  ? (parseFloat(hydEl.value)  || 75) : 75;
  var saltPct   = saltEl ? (parseFloat(saltEl.value) || 2)  : 2;

  // Enrichment weights (enriched style only)
  var butterG = 0, eggsCount = 0, milkMl = 0;
  if (slug === 'enriched') {
    var bEl = document.getElementById('bs-s2-butter');
    var eEl = document.getElementById('bs-s2-eggs');
    var mEl = document.getElementById('bs-s2-milk');
    butterG   = bEl ? (parseFloat(bEl.value) || 0) : 0;
    eggsCount = eEl ? (parseInt(eEl.value)   || 0) : 0;
    milkMl    = mEl ? (parseFloat(mEl.value) || 0) : 0;
  }
  var eggsG = eggsCount * 55;
  var enrichmentWeight = butterG + eggsG + milkMl;

  // Custom blend validation
  var blendEl = document.getElementById('bs-s2-flour-blend');
  var blendVal = blendEl ? blendEl.value : 'white';
  if (blendVal === 'custom') {
    var wEl = document.getElementById('bs-s2-custom-white');
    var oEl = document.getElementById('bs-s2-custom-other');
    var wPct = wEl ? (parseFloat(wEl.value) || 0) : 0;
    var oPct = oEl ? (parseFloat(oEl.value) || 0) : 0;
    var errEl = document.getElementById('bs-s2-blend-error');
    if (Math.round(wPct + oPct) !== 100) {
      if (errEl) errEl.style.display = '';
      return;
    }
    if (errEl) errEl.style.display = 'none';
  }

  // Flour derivation: subtract enrichment from total dough, split by hydration + salt
  var doughBase  = totalDough - enrichmentWeight;
  var totalFlour = Math.round(doughBase / (1 + hydration/100 + saltPct/100));
  var totalWater = Math.round(totalFlour * hydration / 100);
  var saltG      = Math.round(totalFlour * saltPct  / 100);

  if (totalFlour <= 0) return;

  // Pre-ferment split
  var pfActive = document.querySelector('.bs-s2-pf-card--active');
  var pfType   = pfActive ? pfActive.id.replace('bs-s2-pf-','') : 'levain';
  var pfPctEl  = document.getElementById('bs-s2-pf-pct');
  var pfHydEl  = document.getElementById('bs-s2-pf-hydration-val');
  var pfPct    = (pfType !== 'none' && pfPctEl) ? (parseFloat(pfPctEl.value) || 20) : 0;
  var pfHyd    = pfHydEl ? (parseFloat(pfHydEl.value) || 100) : 100;

  var pfFlour   = pfType !== 'none' ? Math.round(totalFlour * pfPct / 100) : 0;
  var pfWater   = pfType !== 'none' ? Math.round(pfFlour * pfHyd / 100)    : 0;
  var mainFlour = totalFlour - pfFlour;
  var mainWater = totalWater - pfWater;

  if (mainWater < 0 || mainFlour < 0) {
    var rowsEl2 = document.getElementById('bs-s2-recipe-rows');
    if (rowsEl2) rowsEl2.innerHTML = '<div style="padding:0.75rem 1rem;color:#c0392b;font-size:0.8rem">Pre-ferment is absorbing more water or flour than the formula allows. Reduce pre-ferment % or levain hydration.</div>';
    return;
  }

  // Effective hydration note (enriched)
  if (slug === 'enriched' && totalFlour > 0) {
    var effHyd = Math.round((totalWater + butterG*0.15 + eggsG*0.74 + milkMl*0.87) / totalFlour * 100);
    var effEl  = document.getElementById('bs-s2-eff-hydration');
    if (effEl) effEl.textContent = 'Effective hydration: ≈' + effHyd + '%';
  }

  // Build recipe rows
  var pfLabels = {
    levain:  ['Levain flour',  'Levain water'],
    poolish: ['Poolish flour', 'Poolish water'],
    biga:    ['Biga flour',    'Biga water']
  };
  function recipeRow(name, wg, bp, extraCls) {
    return '<div class="bs-s2-recipe-row' + (extraCls ? ' ' + extraCls : '') + '">' +
      '<span class="bs-s2-rn">' + name + '</span>' +
      '<span class="bs-s2-rw">' + wg + ' g</span>' +
      '<span class="bs-s2-rb">' + bp + '</span></div>';
  }
  var rowsHTML = '';
  if (pfType !== 'none') {
    var lbl = pfLabels[pfType] || [pfType + ' flour', pfType + ' water'];
    rowsHTML += recipeRow(lbl[0], pfFlour,   (pfFlour/totalFlour*100).toFixed(1)+'%', '');
    rowsHTML += recipeRow(lbl[1], pfWater,   (pfWater/totalFlour*100).toFixed(1)+'%', '');
  }
  rowsHTML += recipeRow('Flour (main)', mainFlour, '100%',              'bs-s2-recipe-row--flour');
  rowsHTML += recipeRow('Water (main)', mainWater, (mainWater/totalFlour*100).toFixed(1)+'%', '');
  rowsHTML += recipeRow('Salt',         saltG,     saltPct.toFixed(1)+'%', '');
  if (slug === 'enriched') {
    if (butterG   > 0) rowsHTML += recipeRow('Butter',                       Math.round(butterG), (butterG/totalFlour*100).toFixed(1)+'%', '');
    if (eggsCount > 0) rowsHTML += recipeRow('Eggs (' + eggsCount + ')', eggsG,     (eggsG/totalFlour*100).toFixed(1)+'%', '');
    if (milkMl    > 0) rowsHTML += recipeRow('Milk',                          Math.round(milkMl),  (milkMl/totalFlour*100).toFixed(1)+'%', '');
  }
  var rowsEl = document.getElementById('bs-s2-recipe-rows');
  if (rowsEl) rowsEl.innerHTML = rowsHTML;

  // Totals grid
  var totalsEl = document.getElementById('bs-s2-recipe-totals');
  if (totalsEl) {
    totalsEl.innerHTML =
      '<div class="bs-s2-total-cell"><div class="bs-s2-total-lbl">Total flour</div><div class="bs-s2-total-val">' + totalFlour + ' g</div></div>' +
      '<div class="bs-s2-total-cell"><div class="bs-s2-total-lbl">Total water</div><div class="bs-s2-total-val">' + totalWater + ' g</div></div>' +
      '<div class="bs-s2-total-cell"><div class="bs-s2-total-lbl">Total dough</div><div class="bs-s2-total-val">' + totalDough + ' g</div></div>' +
      '<div class="bs-s2-total-cell"><div class="bs-s2-total-lbl">Hydration</div><div class="bs-s2-total-val">' + hydration + '%</div></div>';
  }

  // Update window.bs
  if (window.bs) {
    window.bs.hydration      = hydration;
    window.bs.saltPct        = saltPct;
    window.bs.preFerment     = pfType;
    window.bs.preFermentPct  = pfPct;
    window.bs.levainHydration = pfHyd;
    window.bs.totalFlour     = totalFlour;
    window.bs.butter         = butterG;
    window.bs.eggs           = eggsCount;
    window.bs.milk           = milkMl;
  }

  // P8-01: GA4 dr_calculator_used. The DOMContentLoaded boot render runs
  // before any interaction, and drGa4CalcUsed ignores it.
  if (window.drGa4CalcUsed) window.drGa4CalcUsed('bread-studio', 'bread-studio');
}


function bsHandoffToPro() {
  var bs = window.bs || {};
  var state = {
    style: bs.style,
    styleName: bs.styleName,
    loafWeight: bs.loafWeight,
    loafCount: bs.loafCount,
    totalDough: bs.totalDough,
    hydration: bs.hydration,
    saltPct: bs.saltPct,
    preFerment: bs.preFerment,
    preFermentPct: bs.preFermentPct,
    levainHydration: bs.levainHydration,
    butter: bs.butter,
    eggs: bs.eggs,
    milk: bs.milk
  };
  var encoded = btoa(JSON.stringify(state));
  window.location.href = 'https://pro.doughrise.store/bread-studio?state=' + encodeURIComponent(encoded);
}

/* Select-all on focus for number inputs */
document.addEventListener('focusin', function(e) {
  if (e.target && e.target.type === 'number') e.target.select();
});